let lockedScrollY = 0;
let isLocked = false;

/**
 * Locks or unlocks page scrolling in an iOS Safari–safe way.
 *
 * iOS Safari ignores `overflow: hidden` on the document for touch scrolling and shifts the whole
 * page to reveal a focused field when the soft keyboard opens, so the page behind a modal stays
 * scrollable and leaks through. Pinning the body with `position: fixed` leaves nothing to scroll,
 * keeping the page put even while the keyboard is open. The scroll position is saved on lock and
 * restored on unlock.
 */
export function setBodyScrollLock(shouldLock: boolean): void {
	if (shouldLock === isLocked) {
		return;
	}
	isLocked = shouldLock;

	const { style } = document.body;

	if (shouldLock) {
		lockedScrollY = window.scrollY;
		style.height = `${document.documentElement.scrollHeight}px`;
		style.position = "fixed";
		style.top = `-${lockedScrollY}px`;
		style.left = "0";
		style.right = "0";
		style.width = "100%";
		style.overflow = "hidden";
		return;
	}

	style.height = "";
	style.position = "";
	style.top = "";
	style.left = "";
	style.right = "";
	style.width = "";
	style.overflow = "";

	// `behavior: "instant"` bypasses `html { scroll-behavior: smooth }`, restoring the position without an animated jump.
	window.scrollTo({ left: 0, top: lockedScrollY, behavior: "instant" });
}
